"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../../hooks");
const ConverterPanelBarWrapper_1 = require("./ConverterPanelBarWrapper");
const MinimizeMaximizeButton_1 = require("./MinimizeMaximizeButton");
const CloseButton_1 = require("./CloseButton");
exports.EmailCanvasConverterPanel = () => {
    const { state: { activeConversionBlockIdx, conversionPanelConversions }, } = hooks_1.useEmailCanvasContext();
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const conversionKeys = Object.keys(conversionPanelConversions);
    const nextVal = activeConversionBlockIdx ? null : conversionKeys[0];
    return (react_1.default.createElement(ConverterPanelBarWrapper_1.EmailCanvasConverterPanelBarWrapper, { conversionCount: conversionKeys.length, isOpen: conversionKeys.length > 0 },
        react_1.default.createElement(MinimizeMaximizeButton_1.MinimizeMaximizeButton, { activeConversionBlockIdx: activeConversionBlockIdx, toggle: () => {
                dispatchCanvasAction({
                    data: {
                        activeConversionBlockIdx: nextVal,
                    },
                    type: 'state',
                });
            } }),
        react_1.default.createElement(CloseButton_1.CloseButton, { onClose: () => {
                dispatchCanvasAction({
                    data: {
                        activeConversionBlockIdx: null,
                        conversionPanelConversions: {},
                    },
                    type: 'state',
                });
            } })));
};
//# sourceMappingURL=index.js.map